/**
 * Pure array utilities. No React dependencies.
 */

/**
 * Return a new array with only the first occurrence of each value for the given key.
 * @param {Array<object>} arr - Array of objects
 * @param {string} key - Property name to distinct by (default 'id')
 * @returns {Array<object>}
 */
export function distinctByKey(arr, key = 'id') {
  if (!Array.isArray(arr)) return [];
  const seen = new Set();
  return arr.filter((item) => {
    const k = item?.[key];
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
